import styled from 'styled-components';

import { ButtonLink } from '../../../components/Toolkit/Button/ButtonLink';

import { media } from '../../../helpers/breakpoints';

const ShowPhoneNumberButtonLink = styled(ButtonLink)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ShowPhoneNumberText = styled.span`
  ${media.smallOnly} {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding: ${({ theme }) => `0 ${theme.spacing.S12}`};
  }
`;

export { ShowPhoneNumberButtonLink, ShowPhoneNumberText };
